import * as React from 'react';
import { IIconProps } from './IIconProps';

const Battery100: React.FunctionComponent<IIconProps> = ({ size = 'sm', color = "currentColor" }) => {
    return <svg width={24} height={14} viewBox="0 0 24 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M18.7778 1H3.22222C1.99492 1 1 1.89543 1 3V11C1 12.1046 1.99492 13 3.22222 13H18.7778C20.0051 13 21 12.1046 21 11V3C21 1.89543 20.0051 1 18.7778 1Z" stroke={"#7E818A"} strokeLinecap="round" strokeLinejoin="round" />
        <path d="M17.2222 3H4.77778C3.79594 3 3 3.59695 3 4.33333V9.66667C3 10.403 3.79594 11 4.77778 11H17.2222C18.2041 11 19 10.403 19 9.66667V4.33333C19 3.59695 18.2041 3 17.2222 3Z" fill="#595B64" />
        <path d="M23 9V5" stroke={"#7E818A"} strokeLinecap="round" strokeLinejoin="round" />
    </svg>

};

export default Battery100;
